import { graphCambridgeBlue, secondaryBase, skyDark } from '../../../../../../styles/design-tokens';

/**
 * Get the color for a specific dataKey in the initiative progress chart
 * @param dataKey The dataKey of the chart item
 * @param defaultColor The default color to use if no specific color is assigned
 * @returns The color to use for the chart item
 */
const getItemColor = (dataKey: string, defaultColor?: string): string => {
  switch (dataKey) {
    case 'total':
      return secondaryBase;
    case 'completed':
      return graphCambridgeBlue;
    case 'projection':
      return skyDark;
    default:
      return defaultColor || skyDark;
  }
};

export { getItemColor };
